class TemporaryUrlSerivice {
    _DB_KEY = 'temporary_url';

    getTemporaryUrls = (db) => {
        return db.collection(this.dbKey).get();
    }

    addTemporaryUrl = (db, payload) => {
        const document = db.collection(this.dbKey).doc();
        const body = {
            uuid: document.id,
            active: true,
            fileName: payload.fileName,
            fileType: payload.fileType,
            fileUuid: payload.fileUuid,
            url: payload.url
        };

        return document.set(body);
    }

    getTemporaryUrlByFileUuid = (db, uuid) => {
        const collection = db.collection(this.dbKey).where(`fileUuid`, "==", uuid);

        return collection.get();
    }

    getFileByUUID = (db, uuid) => {
        const document = db.collection(this.dbKey).doc(uuid);

        return document.get();
    }

    changeTemporaryUrlStatus = async (db, uuid, status) => {
        const documentRef = db.collection(this.dbKey).doc(uuid);

        return documentRef.update({ active: status });
    }

    deleteTemporaryUrl = async (db, uuid) => {
        const document = db.collection(this.dbKey).doc(uuid);

        return document.delete();
    }

    get dbKey() {
        return this._DB_KEY
    }
}

export default new TemporaryUrlSerivice();



// WEBPACK FOOTER //
// ./src/services/temporary-url.js